export enum ClinicalActivityStatus {
  New = "NEW",
  InProgress = "INPRG",
  Completed = "CMPLT",
  NoResponse = "NORESP",
  Declined = "DECLINED",
  NoLongerRequired = "NLR"
}
